import React from "react";
import { Container, Row } from "react-bootstrap";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import CrearSuperInstituto from "./crear-super-instituto";

const CrearSuperInstitutoClassics = () => {
  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <CreateOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Agregar un nuevo Super Instituto</div>
      </div>
      <Container fluid>
        <Row>
          <CrearSuperInstituto />
        </Row>
      </Container>
    </>
  );
};

export default CrearSuperInstitutoClassics; 